import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";

class FeeCard extends Component {
  render() {
    return (
      <div className="border shadow-sm rounded mb-3 p-3">
        <div className="th-12 th-medium th-cap">{this.props.title}</div>
        <div className="mt-2">
          <Accordion defaultActiveKey={null}>
            <div>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                style={{
                  padding: 0,
                  textDecoration: "none",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="th-12 th-black text-left">
                      Subject: {this.props.date}
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="th-grey th-12 pr-1">Details</div>
                    <i
                      className="fa fa-angle-down th-primary"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <div className="mt-2">
                  <div className="d-flex justify-content-between">
                    <div className="th-12 th-grey th-medium text-left">
                      Exam Date:
                    </div>
                    <div className="th-12 th-grey text-left">
                      {this.props.detail.exam_date}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="th-12 th-grey th-medium text-left">
                      Start Time:
                    </div>
                    <div className="th-12 th-grey text-left">
                      {this.props.detail.start_time}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="th-12 th-grey th-medium text-left">
                      Duration(Min):
                    </div>
                    <div className="th-12 th-grey text-left">
                      {this.props.detail.duration_min}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="th-12 th-grey th-medium text-left">
                      Max. Marks:
                    </div>
                    <div className="th-12 th-grey text-left">
                      {this.props.detail.max_marks}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="th-12 th-grey th-medium text-left">
                      Additional Info:
                    </div>
                    <div className="th-12 th-grey text-left">
                      {this.props.detail.additional_information}
                    </div>
                  </div>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
    );
  }
}
export default FeeCard;
